import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

export default class extends Controller {
  static targets = ['container', 'citySelect'];

  static values = {
    url: String,
    param: String,
    fieldName: String,
    notNewItem: Boolean,
    additionalParams: Object,
    containerId: String
  };

  change(event) {
    const params = new URLSearchParams();

    if (event.target.multiple) {
      Array.from(event.target.selectedOptions).forEach(option => {
        params.append(`${this.paramValue}[]`, option.value);
      });
    } else {
      params.append(this.paramValue, event.target.value);
    }

    if (this.containerIdValue) {
      params.append('target', this.containerIdValue);
    } else {
      this.containerTargets.map(container => params.append(container.dataset.container || 'container', container.id));
    }

    if (this.fieldNameValue) params.append('field_name', this.fieldNameValue);
    this.selectedCities().forEach((city) => params.append('selected_cities[]', city));

    Object.entries(this.additionalParamsValue).forEach(([key, value]) => {
      params.append(key, value);
    });

    params.append('not_new_item', this.notNewItemValue);

    get(`${this.urlValue}?${params}`, {
      responseKind: 'turbo-stream'
    });
  }

  selectedCities() {
    if (!this.hasCitySelectTarget) return [];

    return Array.from(this.citySelectTarget.selectedOptions, ({ value }) => value);
  }
}
